import { createFileRoute, redirect } from '@tanstack/react-router';

/** `/settings` → `/settings/scoring`. */
export const Route = createFileRoute('/_auth/settings/')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/scoring', replace: true });
  },
});
